// src/pages/AbonnementsEdit.js - VERSION CORRIGÉE
import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import axios from "axios";
import Layout from "../components/Layout";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost/securecontrol-backend";

const AbonnementsEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    libele_abonnement: "",
    date_fin_abonnement: "",
    montant_abonnement: "",
    statut_abonnement: "1"
  });

  const [abonnement, setAbonnement] = useState(null);
  const [societe, setSociete] = useState(null);
  const [offre, setOffre] = useState(null);
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [currentProfile, setCurrentProfile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState("");

  const COLORS = {
    primary: '#0B3C5D',
    secondary: '#1E88C8',
    accent: '#4FC3F7',
    darkText: '#2E2E2E',
    lightBg: '#F5F7FA',
    white: '#FFFFFF',
    danger: '#f44336',
    success: '#4caf50',
    warning: '#ff9800',
    info: '#2196f3'
  };

  useEffect(() => {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        setCurrentProfile(String(user.profile));
      } catch (e) {
        console.error("Erreur parsing user:", e);
      }
    }
  }, []);

  useEffect(() => {
    if (currentProfile && id) {
      fetchAbonnementDetails();
    }
  }, [id, currentProfile]);

  const fetchAbonnementDetails = async () => {
    setLoading(true);
    setServerError("");
    try {
      const token = localStorage.getItem("access_token");
      if (!token) {
        setServerError("Session expirée. Veuillez vous reconnecter.");
        setTimeout(() => navigate("/login"), 2000);
        return;
      }

      console.log("Fetching abonnement ID:", id);
      
      // CORRECTION ICI : Utiliser l'endpoint correct
      const response = await axios.get(
        `${API_BASE_URL}/abonnements/get.php?id=${id}`,
        {
          headers: { 
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      console.log("Response data:", response.data);

      if (response.data?.success) {
        // CORRECTION ICI : Votre backend retourne "abonnement" (singulier)
        const data = response.data.abonnement;
        
        if (data) {
          setAbonnement(data);
          
          // Remplir le formulaire
          setForm({
            libele_abonnement: data.libele_abonnement || "",
            date_fin_abonnement: data.date_fin 
              ? data.date_fin.split(' ')[0]
              : "",
            montant_abonnement: data.montant?.toString() || data.montant_abonnement?.toString() || "",
            statut_abonnement: String(data.statut_abonnement) || "1"
          });

          // Récupérer les infos société et offre
          if (data.id_societe) {
            fetchSocieteDetails(data.id_societe);
          }
          if (data.offre?.id_offre || data.id_offre) {
            fetchOffreDetails(data.offre?.id_offre || data.id_offre);
          }
        } else {
          setServerError("Données d'abonnement non disponibles.");
        }
      } else {
        setServerError(response.data?.message || "Abonnement non trouvé.");
      }
    } catch (error) {
      console.error("Erreur détaillée:", error);
      
      if (error.response) {
        const { status, data } = error.response;
        
        if (status === 401) {
          setServerError("Session expirée. Veuillez vous reconnecter.");
          setTimeout(() => navigate("/login"), 2000);
        } else if (status === 403) {
          setServerError("Accès refusé. Vous n'avez pas la permission de voir cet abonnement.");
        } else if (status === 404) {
          setServerError("Abonnement non trouvé.");
        } else {
          setServerError(`Erreur ${status}: ${data?.message || "Impossible de charger l'abonnement."}`);
        }
      } else if (error.request) {
        setServerError("Serveur inaccessible. Vérifiez votre connexion.");
      } else {
        setServerError(`Erreur: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchSocieteDetails = async (societeId) => {
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get(
        `${API_BASE_URL}/societes/get.php?id=${societeId}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      if (response.data?.success && response.data.societe) {
        setSociete(response.data.societe);
      }
    } catch (error) {
      console.error("Erreur chargement société:", error);
    }
  };

  const fetchOffreDetails = async (offreId) => {
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get(
        `${API_BASE_URL}/offres/get.php?id=${offreId}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      if (response.data?.success && response.data.offre) {
        setOffre(response.data.offre);
      }
    } catch (error) {
      console.error("Erreur chargement offre:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const e = {};
    
    if (!form.libele_abonnement?.trim()) {
      e.libele_abonnement = "Le libellé est requis.";
    }
    
    if (!form.date_fin_abonnement) {
      e.date_fin_abonnement = "La date de fin est requise.";
    } else if (abonnement?.date_debut) {
      const dateFin = new Date(form.date_fin_abonnement);
      const dateDebut = new Date(abonnement.date_debut.split(' ')[0]);
      
      if (dateFin <= dateDebut) {
        e.date_fin_abonnement = "La date de fin doit être après la date de début.";
      }
    }
    
    const montant = parseFloat(form.montant_abonnement);
    if (isNaN(montant) || montant <= 0) {
      e.montant_abonnement = "Le montant doit être un nombre supérieur à 0.";
    }
    
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async (action = "modifier") => {
    if (action === "modifier" && !validateForm()) {
      return;
    }

    setSubmitting(true);
    setServerError("");

    try {
      const token = localStorage.getItem("access_token");
      
      // CORRECTION : Utiliser axios.put pour l'update
      let dataToSend = { id_abonnement: parseInt(id) };

      if (action === "modifier") {
        dataToSend = {
          ...dataToSend,
          libele_abonnement: form.libele_abonnement.trim(),
          date_fin_abonnement: form.date_fin_abonnement + " 23:59:59",
          montant_abonnement: parseFloat(form.montant_abonnement),
          statut_abonnement: parseInt(form.statut_abonnement)
        };
      } else if (action === "desactiver") {
        dataToSend.statut_abonnement = 0;
      } else if (action === "activer") {
        dataToSend.statut_abonnement = 1;
      }

      console.log("Sending update:", dataToSend);

      // CORRECTION ICI : Votre backend attend une requête PUT ou POST
      const response = await fetch(`${API_BASE_URL}/abonnements/update.php`, {
        method: 'POST', // ou 'PUT' selon votre configuration
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend)
      });

      const data = await response.json();
      console.log("Update response:", data);

      if (data.success) {
        let message = "";
        
        switch(action) {
          case "modifier":
            message = "✅ Abonnement modifié avec succès.";
            break;
          case "desactiver":
            message = "✅ Abonnement désactivé avec succès.";
            break;
          case "activer":
            message = "✅ Abonnement activé avec succès.";
            break;
        }
        
        setSuccessMsg(message);
        
        // Rafraîchir les données
        setTimeout(() => {
          fetchAbonnementDetails();
        }, 1500);
        
        setShowModal(false);
      } else {
        setServerError(data.message || "Erreur lors de l'opération.");
      }
    } catch (error) {
      console.error("Erreur update:", error);
      setServerError("Erreur de connexion au serveur.");
    } finally {
      setSubmitting(false);
    }
  };

  const formatPrix = (montant) => {
    const montantArrondi = Math.round(parseFloat(montant) || 0);
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'XOF',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(montantArrondi);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Non spécifié";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }) + " " + date.toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return dateString;
    }
  };

  const calculerJoursRestants = (dateFin) => {
    if (!dateFin) return 0;
    const fin = new Date(dateFin);
    const aujourdhui = new Date();
    const difference = fin.getTime() - aujourdhui.getTime();
    const jours = Math.ceil(difference / (1000 * 3600 * 24));
    return jours > 0 ? jours : 0;
  };

  const openModal = (type) => {
    setActionType(type);
    setShowModal(true);
  };

  // Permission check
  if (currentProfile && currentProfile !== "1") {
    return (
      <Layout>
        <div className="pagetitle">
          <h1 style={{ color: COLORS.primary, fontWeight: '600' }}>Modifier l'abonnement</h1>
        </div>
        <section className="section">
          <div className="card">
            <div className="card-body text-center py-5">
              <div className="mb-4">
                <i className="bi bi-shield-lock text-danger fs-1"></i>
              </div>
              <h5 className="mb-3">Accès refusé</h5>
              <p className="text-muted mb-4">Seul l'administrateur peut modifier les abonnements.</p>
              <button className="btn btn-primary" onClick={() => navigate("/abonnements")}>
                <i className="bi bi-arrow-left me-2"></i>
                Retour aux abonnements
              </button>
            </div>
          </div>
        </section>
      </Layout>
    );
  }

  if (loading) {
    return (
      <Layout>
        <div className="pagetitle">
          <h1 style={{ color: COLORS.primary }}>Modifier l'abonnement</h1>
        </div>
        <section className="section">
          <div className="card">
            <div className="card-body text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Chargement...</span>
              </div>
              <p className="mt-3">Chargement des données...</p>
            </div>
          </div>
        </section>
      </Layout>
    );
  }

  if (!abonnement && !loading) {
    return (
      <Layout>
        <div className="pagetitle">
          <h1 style={{ color: COLORS.primary }}>Modifier l'abonnement</h1>
        </div>
        <section className="section">
          <div className="card">
            <div className="card-body text-center py-5">
              <div className="mb-4">
                <i className="bi bi-exclamation-triangle text-warning fs-1"></i>
              </div>
              <h5 className="mb-3">Abonnement non trouvé</h5>
              <p className="text-muted mb-4">
                {serverError || "L'abonnement que vous cherchez n'existe pas ou a été supprimé."}
              </p>
              <div className="mt-4">
                <button className="btn btn-primary me-2" onClick={() => navigate("/abonnements")}>
                  <i className="bi bi-arrow-left me-2"></i>
                  Retour aux abonnements
                </button>
                <button className="btn btn-outline-secondary" onClick={fetchAbonnementDetails}>
                  <i className="bi bi-arrow-clockwise me-2"></i>
                  Réessayer
                </button>
              </div>
              {serverError && (
                <div className="mt-4">
                  <button 
                    className="btn btn-link text-muted" 
                    onClick={() => console.log("Détails:", { id, abonnement, serverError })}
                  >
                    <small>Voir les détails techniques</small>
                  </button>
                </div>
              )}
            </div>
          </div>
        </section>
      </Layout>
    );
  }

  const joursRestants = calculerJoursRestants(abonnement.date_fin);
  const isActif = abonnement.statut_abonnement == 1;

  return (
    <Layout>
      <div className="pagetitle">
        <h1 style={{ color: COLORS.primary, fontWeight: '600' }}>
          <i className="bi bi-pencil-square me-2"></i>
          Modifier l'abonnement
        </h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
            <li className="breadcrumb-item"><Link to="/abonnements">Abonnements</Link></li>
            <li className="breadcrumb-item active">
              {abonnement.libele_abonnement || `Abonnement #${id}`}
            </li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-10 mx-auto">
            {/* Messages */}
            {serverError && (
              <div className="alert alert-danger alert-dismissible fade show mb-4">
                <div className="d-flex align-items-center">
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  <div className="flex-grow-1">{serverError}</div>
                  <button type="button" className="btn-close" onClick={() => setServerError("")}></button>
                </div>
              </div>
            )}
            
            {successMsg && (
              <div className="alert alert-success alert-dismissible fade show mb-4">
                <div className="d-flex align-items-center">
                  <i className="bi bi-check-circle me-2"></i>
                  <div className="flex-grow-1">{successMsg}</div>
                  <button type="button" className="btn-close" onClick={() => setSuccessMsg("")}></button>
                </div>
              </div>
            )}

            {/* Carte de résumé */}
            <div className="card mb-4">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <h5 style={{ color: COLORS.primary }}>
                      {abonnement.libele_abonnement}
                    </h5>
                    <div className="d-flex align-items-center gap-2 mt-2">
                      <span className={`badge ${isActif ? 'bg-success' : 'bg-secondary'}`}>
                        {isActif ? 'Actif' : 'Inactif'}
                      </span>
                      <span className="text-muted small">
                        <i className="bi bi-calendar me-1"></i>
                        Créé le {formatDate(abonnement.created_at)}
                      </span>
                    </div>
                  </div>
                  <div className="text-end">
                    <div className="fw-bold" style={{ color: COLORS.primary, fontSize: '1.5rem' }}>
                      {formatPrix(abonnement.montant || abonnement.montant_abonnement)}
                    </div>
                    <div className="text-muted small">Montant total</div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <div className="card h-100" style={{ backgroundColor: '#f8f9fa' }}>
                      <div className="card-body">
                        <h6 className="card-title small text-muted mb-2">
                          <i className="bi bi-building me-2"></i>
                          Société
                        </h6>
                        {societe ? (
                          <>
                            <div className="fw-semibold">{societe.nom_societe}</div>
                            <div className="small text-muted">{societe.email}</div>
                          </>
                        ) : (
                          <div className="text-muted small">Chargement...</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <div className="card h-100" style={{ backgroundColor: '#f8f9fa' }}>
                      <div className="card-body">
                        <h6 className="card-title small text-muted mb-2">
                          <i className="bi bi-box me-2"></i>
                          Offre
                        </h6>
                        {offre ? (
                          <>
                            <div className="fw-semibold">{offre.libele_offre}</div>
                            <div className="small text-muted">
                              {offre.type_offre} • {offre.duree_mois} mois
                            </div>
                          </>
                        ) : abonnement.offre ? (
                          <>
                            <div className="fw-semibold">{abonnement.offre.libele_offre}</div>
                            <div className="small text-muted">
                              {abonnement.offre.type_offre} • {abonnement.offre.duree_mois} mois
                            </div>
                          </>
                        ) : (
                          <div className="text-muted small">Non spécifiée</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <div className="card h-100" style={{ backgroundColor: '#f8f9fa' }}>
                      <div className="card-body">
                        <h6 className="card-title small text-muted mb-2">
                          <i className="bi bi-calendar-range me-2"></i>
                          Période
                        </h6>
                        <div className="small">
                          <div className="mb-1">
                            <span className="text-muted">Début:</span>
                            <div className="fw-semibold">{formatDate(abonnement.date_debut)}</div>
                          </div>
                          <div>
                            <span className="text-muted">Fin:</span>
                            <div className="fw-semibold">{formatDate(abonnement.date_fin)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Jours restants</span>
                      <span className={`fw-bold ${joursRestants > 30 ? 'text-success' : joursRestants > 7 ? 'text-warning' : 'text-danger'}`}>
                        {joursRestants} jours
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="text-muted">Mode de paiement</span>
                      <span className="fw-semibold">
                        {abonnement.mode_paiement === 'manuel' ? 'Manuel' : 'En ligne'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Formulaire de modification */}
            <div className="card">
              <div className="card-body">
                <h5 className="mb-4" style={{ color: COLORS.primary }}>
                  <i className="bi bi-gear me-2"></i>
                  Modifier les informations
                </h5>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">
                      Libellé <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="libele_abonnement"
                      className={`form-control ${errors.libele_abonnement ? 'is-invalid' : ''}`}
                      value={form.libele_abonnement}
                      onChange={handleChange}
                      placeholder="Ex: Abonnement Premium"
                    />
                    {errors.libele_abonnement && (
                      <div className="invalid-feedback d-block">{errors.libele_abonnement}</div>
                    )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">
                      Date de fin <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      name="date_fin_abonnement"
                      className={`form-control ${errors.date_fin_abonnement ? 'is-invalid' : ''}`}
                      value={form.date_fin_abonnement}
                      onChange={handleChange}
                      min={abonnement.date_debut ? abonnement.date_debut.split(' ')[0] : ''}
                    />
                    {errors.date_fin_abonnement && (
                      <div className="invalid-feedback d-block">{errors.date_fin_abonnement}</div>
                    )}
                    <small className="text-muted d-block mt-1">
                      Actuellement: {formatDate(abonnement.date_fin)}
                    </small>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">
                      Montant (FCFA) <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">FCFA</span>
                      <input
                        type="number"
                        name="montant_abonnement"
                        className={`form-control ${errors.montant_abonnement ? 'is-invalid' : ''}`}
                        value={form.montant_abonnement}
                        onChange={handleChange}
                        min="0"
                        step="100"
                      />
                    </div>
                    {errors.montant_abonnement && (
                      <div className="invalid-feedback d-block">{errors.montant_abonnement}</div>
                    )}
                    <small className="text-muted d-block mt-1">
                      Actuellement: {formatPrix(abonnement.montant || abonnement.montant_abonnement)}
                    </small>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">Statut</label>
                    <select
                      name="statut_abonnement"
                      className="form-select"
                      value={form.statut_abonnement}
                      onChange={handleChange}
                    >
                      <option value="1">Actif</option>
                      <option value="0">Inactif</option>
                    </select>
                    <small className="text-muted d-block mt-1">
                      Statut actuel: {isActif ? 'Actif' : 'Inactif'}
                    </small>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-5 pt-4 border-top">
                  <div>
                    <button
                      className="btn btn-outline-primary me-2"
                      onClick={() => navigate("/abonnements")}
                      disabled={submitting}
                    >
                      <i className="bi bi-arrow-left me-2"></i>
                      Retour
                    </button>
                    
                    {isActif ? (
                      <button
                        className="btn btn-outline-warning"
                        onClick={() => openModal("desactiver")}
                        disabled={submitting}
                      >
                        <i className="bi bi-pause-circle me-2"></i>
                        Désactiver
                      </button>
                    ) : (
                      <button
                        className="btn btn-outline-success"
                        onClick={() => openModal("activer")}
                        disabled={submitting}
                      >
                        <i className="bi bi-play-circle me-2"></i>
                        Activer
                      </button>
                    )}
                  </div>

                  <div>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleSubmit("modifier")}
                      disabled={submitting}
                    >
                      {submitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Enregistrement...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-check-circle me-2"></i>
                          Enregistrer
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal de confirmation */}
      {showModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header" style={{ 
                backgroundColor: actionType === "desactiver" ? COLORS.warning : COLORS.success,
                color: COLORS.white
              }}>
                <h5 className="modal-title">
                  <i className={`bi ${actionType === "desactiver" ? 'bi-exclamation-triangle' : 'bi-check-circle'} me-2`}></i>
                  {actionType === "desactiver" ? 'Désactiver l\'abonnement' : 'Activer l\'abonnement'}
                </h5>
                <button 
                  type="button" 
                  className="btn-close btn-close-white" 
                  onClick={() => setShowModal(false)}
                  disabled={submitting}
                ></button>
              </div>
              <div className="modal-body">
                {actionType === "desactiver" ? (
                  <>
                    <div className="alert alert-warning mb-3">
                      <i className="bi bi-exclamation-triangle me-2"></i>
                      <strong>Attention !</strong> Cette action désactivera l'abonnement.
                    </div>
                    <p>Êtes-vous sûr de vouloir désactiver cet abonnement ?</p>
                  </>
                ) : (
                  <>
                    <div className="alert alert-success mb-3">
                      <i className="bi bi-check-circle me-2"></i>
                      <strong>Activation</strong> de l'abonnement
                    </div>
                    <p>Êtes-vous sûr de vouloir activer cet abonnement ?</p>
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                  disabled={submitting}
                >
                  Annuler
                </button>
                <button
                  type="button"
                  className={`btn ${actionType === "desactiver" ? 'btn-warning' : 'btn-success'}`}
                  onClick={() => handleSubmit(actionType)}
                  disabled={submitting}
                >
                  {submitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Traitement...
                    </>
                  ) : actionType === "desactiver" ? (
                    'Oui, désactiver'
                  ) : (
                    'Oui, activer'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default AbonnementsEdit;